const HRExperiences = ["現採用担当", "過去採用担当経験者", "その他"] as const;

export default HRExperiences;
